import { ICustomAppEventNames } from "interfaces/CustomAppEvents/customAppEventsParams.interface";

const CUSTOM_APP_EVENT_NAMES: ICustomAppEventNames = {
  view_popup: "view_popup",
  click_popup_button: "click_popup_button",
  view_screen: "view_screen",
  click_button: "click_button",
  complete_store_details: "complete_store_details",
  choose_store_format: "choose_store_format",
  save_pin: "save_pin",
  complete_store_address: "complete_store_address",
  complete_store_profile: "complete_store_profile",
  success_otp: "success_otp",
  incorrect_otp: "incorrect_otp",
  submit_terms_confirmation: "submit_terms_confirmation",
  complete_ibang_negosyo_survey: "complete_ibang_negosyo_survey",
  click_item_card: "click_item_card",
  close_popup: "close_popup",
  click_CRM_banner: "click_CRM_banner",
  view_CRM_banner: "view_CRM_banner",
  submit_security_questions: "submit_security_questions",
};

export { CUSTOM_APP_EVENT_NAMES };
